import { render } from "./ModalEdicaoMeuPerfil.vue?vue&type=template&id=29a3ada5&ts=true"
import script from "./ModalEdicaoMeuPerfil.vue?vue&type=script&lang=ts"
export * from "./ModalEdicaoMeuPerfil.vue?vue&type=script&lang=ts"

import "./ModalEdicaoMeuPerfil.vue?vue&type=style&index=0&id=29a3ada5&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__